import { z } from "../../wire/zod";

export const canConnectResponseSchema = z.object({ canConnect: z.boolean() });
export const createAdoSyncSessionResponseSchema = z.object({ syncSessionId: z.string() });
export const getAdoArtMappingSourcesResponseSchema = z.object({
  sources: z
    .array(
      z.object({ id: z.string().optional(), name: z.string().optional(), areaPath: z.string() }),
    )
    .describe("Mapping sources for a single ART, area paths in ADO-native backslash form"),
});
export const getAdoIterationsResponseSchema = z.object({
  iterations: z.array(z.object({ id: z.string(), name: z.string() })),
});
export const getAdoKanbanConfigsResponseSchema = z.object({
  configs: z.record(z.string(), z.array(z.record(z.string(), z.any()))),
});
export const getAdoPatResponseSchema = z.object({ pat: z.string() });
export const getAdoProjectIdResponseSchema = z.object({ projectId: z.string() });
export const getAdoProjectsResponseSchema = z.object({
  projects: z.array(z.object({ id: z.string(), name: z.string() })),
});
export const getAdoTeamMappingResponseSchema = z.object({
  mapping: z.array(
    z.object({
      teamId: z.number().int(),
      sources: z.array(
        z.object({
          id: z.number().int().optional(),
          name: z.string().optional(),
          areaPath: z.string(),
        }),
      ),
    }),
  ),
});
export const getAdoTeamMappingSourcesResponseSchema = z.object({
  sources: z
    .array(
      z.object({
        id: z.number().int().optional(),
        name: z.string().optional(),
        areaPath: z.string(),
      }),
    )
    .describe("Mapping sources for a single team, area paths in ADO-native backslash form"),
});
export const getAdoUsernameResponseSchema = z.object({ username: z.string() });
export const getAdoWebhookEndpointResponseSchema = z.object({ url: z.string() });
export const getAdoWorkItemFieldsResponseSchema = z.object({
  fields: z.array(
    z.object({
      referenceName: z.string(),
      name: z.string(),
      type: z.string(),
      supportedOperations: z.array(z.object({ name: z.string() })),
    }),
  ),
});
export const getAdoWorkItemTypesResponseSchema = z.object({
  workItemTypes: z.array(z.object({ name: z.string(), referenceName: z.string() })),
});
export const getAdoWorkitemLinkTypesResponseSchema = z.object({
  linkTypes: z.array(z.object({ name: z.string(), referenceName: z.string() })),
});
export const noDataSchema = z.record(z.string(), z.never());
export const validateAdoPathResponseSchema = z.object({
  path: z.union([z.string(), z.null()]).optional(),
});
